module.exports = __webpack_public_path__ + "static/media/sm-lib.bbc6fd6b.svg";